import { actions, paths } from 'src/constants';
import { MAX_PAGE_SIZE } from 'src/constants/common';

export default {
  getCollections: (page, pageSize = MAX_PAGE_SIZE) => ({
    [actions.API_CALL]: {
      types: [
        actions.WHEEL_OF_FORTUNE_COLLECTIONS_GET_REQUEST,
        actions.WHEEL_OF_FORTUNE_COLLECTIONS_GET_SUCCESS,
        actions.WHEEL_OF_FORTUNE_COLLECTIONS_GET_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.api.WHEEL_OF_FORTUNE, {
          params: {
            page,
            pageSize,
          },
        }),
    },
  }),
  getLevelsByCollectionId: (collectionId) => ({
    [actions.API_CALL]: {
      types: [
        actions.WHEEL_OF_FORTUNE_LEVELS_GET_REQUEST,
        actions.WHEEL_OF_FORTUNE_LEVELS_GET_SUCCESS,
        actions.WHEEL_OF_FORTUNE_LEVELS_GET_FAILURE,
      ],
      promise: (client) =>
        client.get(
          paths.build(
            paths.api.WHEEL_OF_FORTUNE_COLLECTIONS_ID_LEVELS,
            collectionId
          )
        ),
    },
  }),
};
